var map = {
	"./baobiao.svg": "b754",
	"./entry.svg": "f076",
	"./guanwang.svg": "59c7",
	"./home.svg": "f2a5",
	"./kucun.svg": "a57d",
	"./log.svg": "8480",
	"./money.svg": "4f356",
	"./monitor.svg": "88c8",
	"./out.svg": "5f07",
	"./product.svg": "73bb",
	"./recycle-bin.svg": "10f3",
	"./setting.svg": "614f",
	"./warehouse.svg": "33ec",
	"./warning.svg": "45a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";